import { Filter } from "@dto/records";
import { hasFilterOnPath } from "@utils/filters";

// hideEmptyCategories tells whether the category group of a chart is requested
// with hideEmptyGroups. Categories without any record once the widget filter is
// applied are hidden unless the widget asks to show them. A filter on the
// category field itself always hides them: the backend lists the possible group
// values without the widget filter, which would bring back the excluded ones.
export function hideEmptyCategories(showEmptyCategories: boolean | undefined, filter: Filter | null | undefined, categoryPathKey: string): boolean {
    return showEmptyCategories !== true || hasFilterOnPath(filter, categoryPathKey);
}
